import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiHiringPlanApproveRequest,
  ApiHiringPlanConfirmationCommentUpdate,
  ApiHiringPlanFilter,
  ApiHiringPlanPayload,
  ApiHiringPlanRequest,
  ApiPagedHiringPlanData,
} from "@/types/recruit/hiring-plan.types.ts";

export const apiHiringPlan = {
  search: (filter: ApiHiringPlanFilter, signal?: AbortSignal) => {
    return api.post<ApiPagedHiringPlanData>("/api/v1/hiring-plans/search", filter, signal);
  },
  createRequest: (payload: ApiHiringPlanPayload) => {
    return api.post<ApiHiringPlanRequest>("/api/v1/hiring-plans", payload);
  },
  getRequestById: (id: number) => {
    return api.get<ApiHiringPlanRequest>(`/api/v1/hiring-plans/${id}`);
  },
  updateRequest: (id: number, payload: ApiHiringPlanPayload) => {
    return api.put<ApiHiringPlanRequest>(`/api/v1/hiring-plans/${id}`, payload);
  },
  deleteRequest: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/hiring-plans/${id}`);
  },
  cancelRequest: (id: number) => {
    return api.post<ApiHiringPlanRequest>(`/api/v1/hiring-plans/${id}/cancel`, {});
  },
  approveRequest: (id: number, payload: ApiHiringPlanApproveRequest) => {
    return api.post<ApiHiringPlanRequest>(`/api/v1/hiring-plans/${id}/approve`, payload);
  },
  rejectRequest: (id: number, payload: ApiHiringPlanApproveRequest) => {
    return api.post<ApiHiringPlanRequest>(`/api/v1/hiring-plans/${id}/reject`, payload);
  },
  updateConfirmationComment: (id: number, body: ApiHiringPlanConfirmationCommentUpdate) => {
    return api.put<ApiOperationResult>(`/api/v1/hiring-plans/${id}/confirmation/comment`, body);
  },
  connectRequestToJob: (requestId: number, jobId: number | null) => {
    return api.post<ApiHiringPlanRequest>(`/api/v1/hiring-plans/${requestId}/job`, {
      job_id: jobId,
    });
  },
};
